<template>
    <modal-live ref="modal" :default-show-modal="false" :dismiss-on-overlay="false">
        <div class="modal-header">
            <h3 class="headline--modal">Truck Presets</h3>
            <span class="modal__icon-close" @click="close()">
                <svg>
                    <use :xlink:href="`${icons['close']}#icon`"></use>
                </svg>
            </span>
        </div>
        <div class="dialog pt-0" v-if="presetDetail">
            <h2 class="text-center color--brown">
                {{ presetDetail.id ? 'Edit Preset' : 'Add Preset' }}
            </h2>
            <table class="w-100">
                <tr>
                    <td class="edit-preset__title">Name</td>
                    <td colspan="2">
                        <input-text
                            :value="presetDetail.label"
                            v-model="presetDetail.label"
                        ></input-text>
                    </td>
                </tr>
                <tr>
                    <td class="edit-preset__title">Truck type</td>
                    <td colspan="2" class="text-right">
                        <input-drop
                            v-model="presetDetail.truckType"
                            :options="truckTypes"
                            :type="'seamless'"
                            class="text-left"
                        >
                        </input-drop>
                    </td>
                </tr>
                <tr>
                    <td class="edit-preset__title text-nowrap">
                        Number of Trailers
                    </td>
                    <td colspan="2" class="text-right">
                        <input-drop
                            v-model="presetDetail.trailers"
                            :options="trailerTypes"
                            :type="'seamless'"
                            class="text-left"
                        >
                        </input-drop>
                    </td>
                </tr>
                <tr>
                    <td class="edit-preset__title">Height</td>
                    <td>
                        <input-number
                            :value="presetDetail.height.ft"
                            v-model="presetDetail.height.ft"
                            append="ft"
                            @change="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    'height_ft',
                                )
                            "
                        ></input-number>
                    </td>
                    <td>
                        <input-number
                            :value="presetDetail.height.in"
                            v-model="presetDetail.height.in"
                            append="in"
                            @change="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    'height_in',
                                )
                            "
                        ></input-number>
                    </td>
                </tr>
                <tr>
                    <td class="edit-preset__title">Lenght</td>
                    <td>
                        <input-number
                            :value="presetDetail.length.ft"
                            v-model="presetDetail.length.ft"
                            append="ft"
                            @change="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    'length_ft',
                                )
                            "
                        ></input-number>
                    </td>
                    <td>
                        <input-number
                            :value="presetDetail.length.in"
                            v-model="presetDetail.length.in"
                            append="in"
                            @change="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    'length_in',
                                )
                            "
                        ></input-number>
                    </td>
                </tr>
                <tr>
                    <td class="edit-preset__title">Width</td>
                    <td>
                        <input-number
                            :value="presetDetail.width.ft"
                            v-model="presetDetail.width.ft"
                            append="ft"
                            @change="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    'width_ft',
                                )
                            "
                        ></input-number>
                    </td>
                    <td>
                        <input-number
                            :value="presetDetail.width.in"
                            v-model="presetDetail.width.in"
                            append="in"
                            @change="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    'width_in',
                                )
                            "
                        ></input-number>
                    </td>
                </tr>
                <tr>
                    <td class="edit-preset__title">Weight limit</td>
                    <td colspan="2">
                        <input-number
                            :value="presetDetail.grossWeight.lb"
                            v-model="presetDetail.grossWeight.lb"
                            append="lb"
                            @change="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    'weight',
                                )
                            "
                        ></input-number>
                    </td>
                </tr>
                <tr>
                    <td class="edit-preset__title">Maximum axle weight</td>
                    <td colspan="2">
                        <input-number
                            :value="presetDetail.weightPerAxle.lb"
                            v-model="presetDetail.weightPerAxle.lb"
                            append="lb"
                            @change="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    'maximumAxleWeight',
                                )
                            "
                        ></input-number>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="color--orange">
                        Hazardous Materials
                    </td>
                </tr>
                <tr
                    v-for="(good, key) in hazardousGoods"
                    :key="`hazardous-good-${key}`"
                >
                    <td class="edit-preset__title">{{ good.label }}</td>
                    <td colspan="2">
                        <on-off
                            :state="
                                presetDetail.shippedHazardousGoods[good.key]
                            "
                            v-model="
                                presetDetail.shippedHazardousGoods[good.key]
                            "
                            @input="
                                trackGoogle(
                                    'TRUCK_PRESETS_EDIT_FIELD',
                                    good.key,
                                )
                            "
                        ></on-off>
                    </td>
                </tr>
            </table>
        </div>
        <div class="modal-footer">
            <Button
                class="text-sm btn-block"
                :disabled="!presetDetail.label"
                @click.native="save()"
                >{{ presetDetail.id ? 'Save' : 'Add Preset' }}</Button
            >
        </div>
    </modal-live>
</template>
<script>
export default {
    data() {
        return {
            icons: window.here.icons,
            presetDetail: {
                label: '',
                truckType: 'Truck',
                trailers: 0,
                height: {
                    ft: 0,
                    in: 0,
                },
                length: {
                    ft: 0,
                    in: 0,
                },
                width: {
                    ft: 0,
                    in: 0,
                },
                grossWeight: {
                    lb: 0,
                },
                weightPerAxle: {
                    lb: 0,
                },
                shippedHazardousGoods: {
                    explosive: false,
                    gas: false,
                    flammable: false,
                    combustible: false,
                    organic: false,
                    poison: false,
                    radioactive: false,
                    corrosive: false,
                    poisonousInhalation: false,
                    harmfulToWater: false,
                    other: false,
                },
            },
            truckTypes: [
                [
                    {
                        label: 'Truck',
                        value: 'truck',
                    },
                    {
                        label: 'Tractor trailer',
                        value: 'tractorTrailer',
                    },
                    {
                        label: 'Garbage truck',
                        value: 'garbageTruck',
                    },
                    {
                        label: 'Tank truck',
                        value: 'tankTruck',
                    },
                    {
                        label: 'Damp truck',
                        value: 'dampTruck',
                    },
                    {
                        label: 'Coach / Bus',
                        value: 'coachBus',
                    },
                ],
            ],
            trailerTypes: [
                [
                    {
                        label: 'None',
                        value: 0,
                    },
                    {
                        label: 'Single',
                        value: 1,
                    },
                    {
                        label: 'Double',
                        value: 2,
                    },
                    {
                        label: 'Triple',
                        value: 3,
                    },
                ],
            ],
            hazardousGoods: [
                {
                    label: 'Explosive',
                    key: 'explosive',
                },
                {
                    label: 'Gas',
                    key: 'gas',
                },
                {
                    label: 'Flammable',
                    key: 'flammable',
                },
                {
                    label: 'Combustible',
                    key: 'combustible',
                },
                {
                    label: 'Organic',
                    key: 'organic',
                },
                {
                    label: 'Poison',
                    key: 'poison',
                },
                {
                    label: 'Radioactive',
                    key: 'radioactive',
                },
                {
                    label: 'Corrosive',
                    key: 'corrosive',
                },
                {
                    label: 'Toxic inhalant',
                    key: 'poisonousInhalation',
                },
                {
                    label: 'Water pollutant',
                    key: 'harmfulToWater',
                },
                {
                    label: 'Other',
                    key: 'other',
                },
            ],
        };
    },
    methods: {
        show(preset) {
            if (preset) {
                this.presetDetail = preset;
            } else {
                this.presetDetail = {
                    label: '',
                    truckType: 'truck',
                    trailers: 0,
                    height: {
                        ft: 0,
                        in: 0,
                    },
                    length: {
                        ft: 0,
                        in: 0,
                    },
                    width: {
                        ft: 0,
                        in: 0,
                    },
                    grossWeight: {
                        lb: 0,
                    },
                    weightPerAxle: {
                        lb: 0,
                    },
                    shippedHazardousGoods: {
                        explosive: false,
                        gas: false,
                        flammable: false,
                        combustible: false,
                        organic: false,
                        poison: false,
                        radioactive: false,
                        corrosive: false,
                        poisonousInhalation: false,
                        harmfulToWater: false,
                        other: false,
                    },
                };
            }
            this.$refs.modal.show();
        },
        close() {
            this.$refs.modal.close();
        },
        save() {
            axios
                .post('/api/v1/truck-preset/save', {
                    session: window.config.session,
                    preset: this.presetDetail,
                })
                .then(({ data }) => {
                    this.$parent.$parent.$emit('updateTruckPresets', data);
                    this.$refs.modal.close();
                })
                .catch(() => {
                    console.log('error');
                });
        },
        trackGoogle(event, tag) {
            this.$gtag.event(event, {
                event_category: 'PLAN',
                value: tag,
            });
        },
    },
};
</script>
